/**
=========================================================
* Soft UI Dashboard React - v4.0.1
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Card from "@mui/material/Card";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";
import SoftTypography from "components/SoftTypography";
import { Link } from "react-router-dom";
import {
  CAvatar,
  CButton,
  CCard,
  CCardBody,
  CCardSubtitle,
  CCardTitle,
  CCol,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CProgress,
  CRow,
  CCardHeader,
  CTable,
  CTableBody,
  CTableDataCell,
  CTableHead,
  CTableHeaderCell,
  CTableRow,
  CWidgetStatsA,
  CForm,
  CFormLabel,
  CFormInput,
  CFormText,
  CFormCheck,
  CModal,
  CModalHeader,
  CModalBody,
  CModalFooter,
  CModalTitle,
  CDateRangePicker
} from '@coreui/react-pro'

// Soft UI Dashboard React examples
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import Table from "examples/Tables/Table";
import { utils, writeFileXLSX } from "xlsx";

// Data
import RecruiterTableData from "layouts/recruiter/data/RecruiterTableData";
import '@coreui/coreui/dist/css/coreui.min.css'
import '@coreui/coreui-pro/dist/css/coreui.min.css'
import jsPDF from 'jspdf'
import autoTable from 'jspdf-autotable'
import { useEffect, useState } from "react";
import { UsersService } from "services/UsersAuth";
import RecruiterEditForm from "./data/RecruiterEditForm";

function Recruiter() {

  const [recruiters, setRecruiters] = useState();
  const [visible, setVisible] = useState(false)
  const [selectedRecruiters, setSelectedRecruiters] = useState({ id: "", status: "" });
  const [startDate, setStartDate] = useState(new Date('2022-01-01'))
  const [endDate, setEndDate] = useState(new Date('2022-03-19'))
  const [editableData, setEditableData] = useState();
  const [VisibleForm, setVisibleForm] = useState(false)
  const minDate = new Date(
    Math.min(
      recruiters?.map((element) => {
        return new Date(Date.parse(element.created_at))
      }),
    ),
  )
  const maxDate = new Date(
    Math.max(
      recruiters?.map((element) => {
        return new Date(Date.parse(element.created_at))
      }),
    ),
  )


  useEffect(() => {
    getUsersDetail()
  }, [])


  const changeStatus = async (id, status) => {
    await UsersService.ActivateDactivateUser(selectedRecruiters.id, selectedRecruiters.status)
    await getUsersDetail()
    setVisible(false)
  }


  const changeStatusConfirmation = async (id, status) => {
    setSelectedRecruiters({ id, status })
    setVisible(true)
  }

  const closeEditForm = () => {
    setVisibleForm(false)
  }

  const getUsersDetail = async () => {
    const studentList = await UsersService?.UserList(4);
    setRecruiters(studentList?.data?.data)
  }

  const RecruiterFormPopup = async (data) => {

    setEditableData(data)
    setVisibleForm(true)
  }

  const columns = [
    { key: 'status', label: 'Status(1 for active 0 for deactive)', _style: { width: '10%', fontSize: '16px' }, filter: true, sorter: false, },
    { key: 'id', _style: { width: '4%', fontSize: '16px' }, filter: true, sorter: true, },
    { key: 'fname', _style: { width: '10%', fontSize: '16px' }, filter: true, sorter: true, },
    { key: 'lname', _style: { width: '10%', fontSize: '16px' }, filter: true, sorter: true, },
    { key: 'email', _style: { width: '22%', fontSize: '16px' }, filter: true, sorter: true, },
    { key: 'companyname', label: "company name", _style: { width: '10%', fontSize: '16px' }, filter: true, sorter: false, },
    { key: 'mobile', _style: { width: '10%', fontSize: '16px' }, filter: true, sorter: false, },
    { key: 'country', _style: { width: '10%', fontSize: '16px' }, filter: true, sorter: true, },
    { key: 'state', _style: { width: '10%', fontSize: '16px' }, filter: true, sorter: true, },
    { key: 'city', _style: { width: '10%', fontSize: '16px' }, filter: true, sorter: true, },
    { key: 'job_amount', _style: { width: '10%', fontSize: '16px' }, filter: true, sorter: true, },
    { key: 'Nationality', label: 'Nationality', _style: { width: '10%', fontSize: '16px' }, filter: true, sorter: true, },
    { key: 'dob', label: 'D-O-B', _style: { width: '10%', fontSize: '16px' }, filter: true, sorter: true, },
    { key: 'request_amount', _style: { width: '10%', fontSize: '16px' }, filter: true, sorter: true, },
    {
      key: 'created_at', _style: { width: '20%', fontSize: '16px' }, filter: (values, onChange) => {
        return (
          <CDateRangePicker
            footer
            size="sm"
            startDate={startDate}
            endDate={endDate}
            minDate={minDate}
            maxDate={maxDate}
            onStartDateChange={(date) => {
              setStartDate(date)
              onChange((item) => {
                if (date) {
                  const itemDate = new Date(Date.parse(item))
                  return endDate ? itemDate >= date && itemDate <= endDate : itemDate >= date
                }
                return true
              })
            }}
            onEndDateChange={(date) => {
              setEndDate(date)
              onChange((item) => {
                if (date) {
                  const itemDate = new Date(Date.parse(item))
                  return startDate ? itemDate <= date && itemDate >= startDate : itemDate <= date
                }
                return true
              })
            }}
          />
        )
      }, sorter: true,
    },
    // { key: 'start_date', _style: { width: '25%', fontSize: '16px' }, filter: false, sorter: false, },
    // { key: 'end_date', _style: { width: '25%', fontSize: '16px' }, filter: false, sorter: false, },
    // { key: 'role', _style: { width: '25%', fontSize: '16px' }, filter: false, sorter: false, },
    { key: 'show_details', label: '', _style: { width: '1%', fontSize: '16px' }, filter: false, sorter: false, },
  ]
  // const downloadPdf = ()=>{
  //   const doc = new jsPDF()

  // autoTable(doc, {
  //   head: [columns],
  //   body: [rows],
  // })
  // doc.save('table.pdf')
  // }


  return (
    <>
      <DashboardLayout>
        <DashboardNavbar />
        <CCardHeader>
          {/* <strong>ADMIN USER DATA</strong> <small></small> */}
        </CCardHeader>
        <SoftBox py={3}>
          <SoftBox mb={3}>
            <CRow>
              <CCol xs={12}>
                <CCard className="mb-4">
                  <CCardHeader>
                    <strong>Total Recruiters Registered</strong> <small></small>

                  </CCardHeader>
                  <CCardBody>
                    <RecruiterTableData columns={columns} data={recruiters} changeStatusConfirmation={changeStatusConfirmation} startDate={startDate} endDate={endDate} RecruiterFormPopup={RecruiterFormPopup} />
                  </CCardBody>
                </CCard>
              </CCol>
            </CRow>
          </SoftBox>
          <CRow>
            <CCol xs={12}>
              <CCard className="mb-4">
                <CCardBody>
                  {/* <usersTableData /> */}
                </CCardBody>
              </CCard>
            </CCol>
          </CRow>
        </SoftBox>
        <Footer />
      </DashboardLayout>
      <CModal
        visible={visible}
        onClose={() => setVisible(false)}
        aria-labelledby="LiveDemoExampleLabel"
        alignment="center"
      >
        <CModalHeader>
          <CModalTitle id="LiveDemoExampleLabel">{selectedRecruiters.status == 1 ? "Activate" : "Deactivate"} Recruiter</CModalTitle>
        </CModalHeader>
        <CModalBody>
          <p>Are you sure you want to {selectedRecruiters.status == 1 ? "active" : "deactive"} recruiter!</p>
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={() => setVisible(false)}>
            No
          </CButton>
          <CButton color="primary" onClick={() => { changeStatus() }}>Yes</CButton>
        </CModalFooter>
      </CModal>




      <CModal
        visible={VisibleForm}
        onClose={() => setVisibleForm(false)}
        aria-labelledby="LiveDemoExampleLabel"
        alignment="center"
      >
        {/* <CModalHeader>
          <CModalTitle id="LiveDemoExampleLabel">Edit Student Detail</CModalTitle>
        </CModalHeader> */}
        <CModalBody style={{ height: '400px', overflowY: 'scroll' }}>
          <RecruiterEditForm data={editableData} closeEditForm={closeEditForm} getUsersDetail={getUsersDetail} />
        </CModalBody>
        <CModalFooter>
          {/* <CButton color="secondary" onClick={() => setVisibleForm(false)}>
            No
          </CButton> */}
          <CButton color="primary" onClick={() => { setVisibleForm(false) }}>Close</CButton>
        </CModalFooter>
      </CModal>
    </>
  );
}

export default Recruiter;

